module.exports = new __parcel__URL__("getting-started-page-app-skeleton.tpl.b9c0d034.svg").toString();